import Vue from 'vue'
import Router from 'vue-router'
import { isMobile } from "mobile-device-detect";

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
const Trending = () => import('@/views/Trending')
const TrendingStories = () => import('@/views/TrendingStories')
const SaveDesign = () => import('@/views/SaveDesign')
const DesignHistory = () => import('@/views/DesignHistory')
const EditDesign = () => import('@/views/EditDesign')
const ImportDesign = () => import('@/views/ImportDesign')
const PSDUpload = () => import('@/views/PSDUpload')
const Mine = () => import('@/views/Mine')
const Favorites = () => import('@/views/Favorites')
const Page404 = () => import('@/views/pages/Page404')
const Login = () => import('@/views/pages/Login')
const Tests = () => import('@/views/pages/Tests')
const EmailConfirmation = () => import('@/views/pages/EmailConfirmation')
const ResetPasswordCreation = () => import('@/views/pages/ResetPasswordCreation')
const Register = () => import('@/views/pages/Register')
const ResetPassword = () => import('@/views/pages/ResetPassword')
const Docs = () => import('@/views/pages/Docs')
const Editor = () => import('@/views/editor/Editor')
const EditorMobile = () => import('@/views/editor/EditorMobile')
const EditorTests = () => import('@/views/editor/EditorTests')
const ChooseColor = () => import('@/views/editor/ChooseColor')
const CustomEditor = () => import('@/views/editor/CustomEditor')
const Preview = () => import('@/views/Preview')
const DownloadVideo = () => import('@/views/DownloadVideo')
const PreviewCarousel = () => import('@/views/PreviewCarousel')
const PreviewCarousel2 = () => import('@/views/PreviewCarousel2')
const PreviewCarouselMine = () => import('@/views/PreviewCarouselMine')
const ChooseColorCarousel = () => import('@/views/ChooseColorCarousel')
const Payments = () => import('@/views/Payments')
const Payments2 = () => import('@/views/Payments2')
const AdminPanel = () => import('@/views/AdminPanel')
const AdminSalesPanel = () => import('@/views/AdminSalesPanel')
const ResellerPanel = () => import('@/views/ResellerPanel')
const PreviewMine = () => import('@/views/PreviewMine')
const Account = () => import('@/views/Account')
const Club = () => import('@/views/Club')
const Tutorial = () => import('@/views/Tutorial')
const FAQ = () => import('@/views/FAQ')
const ResellerManage = () => import('@/views/ResellerManage')
const ResellerUser = () => import('@/views/ResellerUser')
const Coupon = () => import('@/views/Coupon')
const Invite = () => import('@/views/Invite')
const Coupons = () => import('@/views/Coupons')
const Support = () => import('@/views/Support')
const RequestSleeker = () => import('@/views/RequestSleeker')
const ManageDesign = () => import('@/views/ManageDesign')
const CreationManagement = () => import('@/views/CreationManagement')
const CreationAdd = () => import('@/views/CreationAdd')
const CreationUpdate = () => import('@/views/CreationUpdate')
const CreationProductivity = () => import('@/views/CreationProductivity')
const CreationProductivityByAdmin = () => import('@/views/CreationProductivityByAdmin')
const UserEdition = () => import('@/views/UserEdition')
const TemplateEditions = () => import('@/views/TemplateEditions')
const GetToKnow = () => import('@/views/GetToKnow')
const Imersao = () => import('@/views/Imersao')
const FreePass = () => import('@/views/landing/FreePass')
const Whatsapp = () => import('@/views/Whatsapp')
const PreLogin = () => import('@/views/PreLogin')
const PaymentLoad = () => import('@/views/PaymentLoad')
const PaymentSuccess = () => import('@/views/PaymentSuccess')
const PaymentsPage = () => import('@/views/PaymentsPage')
const PaymentsSingle = () => import('@/views/PaymentsSingle')
const Lecture = () => import('@/views/Lecture')
const Lecture2 = () => import('@/views/Lecture2')
const Landing = () => import('@/views/landing/Landing')
const AdminDashboard = () => import('@/views/AdminDashboard')
const AdminHistory = () => import('@/views/AdminHistory')
const AdminFonts = () => import('@/views/AdminFonts')
const CreationSources = () => import('@/views/CreationSources')
const Raffle = () => import('@/views/Raffle')
const EbookMine = () => import('@/views/EbookMine')
const ChooseEbookPages = () => import('@/views/ChooseEbookPages')
const CustomChooseEbookPages = () => import('@/views/CustomChooseEbookPages')
const ChooseEbookCover = () => import('@/views/ChooseEbookCover')
const SaveEbookCover = () => import('@/views/SaveEbookCover')
const SaveEbookPage = () => import('@/views/SaveEbookPage')
const CustomSaveEbookCover = () => import('@/views/CustomSaveEbookCover')
const CustomChooseEbookCover = () => import('@/views/CustomChooseEbookCover')
const Ebook = () => import('@/views/Ebook')
const FreeCredits = () => import('@/views/FreeCredits')
const RandomBonus = () => import('@/views/RandomBonus')
const EbookObrigado = () => import('@/views/EbookObrigado')
const CustomEbookObrigado = () => import('@/views/CustomEbookObrigado')
const CustomEbook = () => import('@/views/CustomEbook')
const Calendar = () => import('@/views/Calendar')
const LandingEspecial = () => import('@/views/landing/LandingEspecial')
const ChallengeList = () => import('@/views/ChallengeList')
const ChallengeListComponent = () => import('@/views/ChallengeListComponent')
const EbookSingle = () => import('@/views/EbookSingle')
const Challenge = () => import('@/views/Challenge')
const Challenge2 = () => import('@/views/Challenge2')
const Home = () => import('@/views/Home')
const DocList = () => import('@/views/DocList')
const DocFinished = () => import('@/views/DocFinished')
const DocHome = () => import('@/views/DocHome')
const SiteHome = () => import('@/views/SiteHome')
const SiteLeads = () => import('@/views/SiteLeads')
const SiteEditor = () => import('@/views/SiteEditor')
const SiteEditorAdmin = () => import('@/views/SiteEditorAdmin')
const SitePage = () => import('@/views/SitePage')
const DocMine = () => import('@/views/DocMine')
const FreePassHome = () => import('@/views/FreePassHome')
const FreePassVideo = () => import('@/views/FreePassVideo')
const FreePassSticker = () => import('@/views/FreePassSticker')

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/especial',
      name: 'LandingEspecial',
      component: LandingEspecial
    },
    {
      path: '/contratar',
      name: 'PagamentosSingle',
      component: PaymentsSingle
    },
    {
      path: '/custom-ebook',
      name: 'CustomEbook',
      component: CustomEbook,
      redirect: '/ebook/list',
      children: [
        {
          path: 'list',
          name: "CustomEbookList",
          component: Ebook
        },
        {
          path: ':id/pages/:idEbook',
          name: "CustomChooseEbookPages",
          component: CustomChooseEbookPages
        },
        {
          path: ':id/cover',
          name: "CustomChooseEbookCover",
          component: CustomChooseEbookCover
        },
        {
          path: ':idEbook/save-cover/:id',
          name: "CustomSaveEbookCover",
          component: CustomSaveEbookCover
        },
        {
          path: 'thank-you/:id',
          name: "CustomEbookObrigado",
          component: CustomEbookObrigado
        },
        {
          path: 'editor',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ':id',
              name: 'CustomEditor',
              component: CustomEditor,
              props: true
            },
          ]
        }
      ]
    },
    {
      path: '/',
      //redirect: '/pages/login',
      name: 'App',
      component: DefaultContainer,
      children: [
        {
          path: 'login',
          redirect: '/pages/login',
        },
        {
          path: 'home',
          name: 'Home',
          component: Home
        }/*,
        {
          path: 'bonus-mentoria-youtube',
          name: 'FreeCredits',
          component: FreeCredits
        }*/,
        {
          path: 'presente-dia-nutri-e-personal',
          name: 'RandomBonus',
          component: RandomBonus
        },
        {
          path: 'calendar',
          name: 'Calendar',
          component: Calendar
        },
        {
          path: 'challenge2',
          name: 'Challenge2',
          component: {
            render (c) { return c('router-view') }
          },
          redirect: '/challenge2/list',
          children: [
            {
              path: 'list',
              name: "ChallengeList2",
              component: ChallengeList
            },
            {
              path: ':id',
              name: "Challenge2",
              component: Challenge2
            }
          ]
        },
        {
          path: 'challenge',
          name: 'ChallengeBase',
          component: {
            render (c) { return c('router-view') }
          },
          redirect: '/challenge/list',
          children: [
            {
              path: 'list',
              name: "ChallengeList",
              component: ChallengeList
            },
            {
              path: ':id',
              name: "Challenge",
              component: Challenge
            }
          ]
        },
        {
          path: 'ebook',
          name: 'Ebook',
          component: {
            render (c) { return c('router-view') }
          },
          redirect: '/ebook/list',
          children: [
            {
              path: 'list',
              name: "EbookList",
              component: Ebook
            },
            {
              path: ':id/pages/:idEbookRequest',
              name: "ChooseEbookPages",
              component: ChooseEbookPages
            },
            {
              path: ':id/cover',
              name: "ChooseEbookCover",
              component: ChooseEbookCover
            },
            {
              path: ':idEbook/save-cover/:id',
              name: "SaveEbookCover",
              component: SaveEbookCover
            },
            {
              path: ':idEbookRequest/save-page/:id',
              name: "SaveEbookPage",
              component: SaveEbookPage
            },
            {
              path: 'thank-you',
              name: "EbookObrigado",
              component: EbookObrigado
            },
            {
              path: 'mine',
              name: "EbookMine",
              component: EbookMine
            }
          ]
        },
        {
          path: 'story',
          //redirect: '/story/search',
          name: 'Story',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'search',
              name: 'StoryRedirect',
              //redirect: '/story/search/1',
              component: {
                render (c) { return c('router-view') }
              },
              children: [{
                path: ':page/:searchId?',
                name: 'StorySearch',
                component: TrendingStories
              }],
            }]
        },
        {
          path: 'design',
          redirect: '/design/search',
          name: 'Design',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'search',
              name: 'BuscaRedirect',
              redirect: '/design/search/1',
              component: {
                render (c) { return c('router-view') }
              },
              children: [{
                path: ':page/:searchId?',
                name: 'Busca',
                component: Trending
              }],
            },
            {
              path: 'import',
              name: 'Importar',
              component: ImportDesign
            },
            {
              path: 'upload-psd',
              name: 'Upload PSD',
              component: PSDUpload
            },
            {
              path: 'manage',
              name: 'Gerenciar',
              component: ManageDesign
            },
            {
              path: 'mine',
              name: 'Meus Designs',
              component: Mine
            },
            {
              path: 'favorites',
              name: 'Favoritos',
              component: Favorites
            },
            {
              path: 'history',
              name: 'Historico',
              component: DesignHistory,
            },
            {
              path: 'save',
              name: 'Salvar',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: ':id/:token?',
                  name: 'SaveDesign',
                  component: SaveDesign,
                }
              ]
            },
            {
              path: 'edit',
              name: 'Editar',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: ':id',
                  name: 'Editar Design',
                  component: EditDesign,
                }
              ]
            },
            {
              path: 'choose-color-carousel',
              name: 'PrePreviewCarousel',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: ':id',
                  name: 'ChooseColorCarousel',
                  component: ChooseColorCarousel,
                }
              ]
            },
            {
              path: 'preview-carousel-mine',
              name: 'PreviewCarouselMine',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: ':id',
                  name: 'PreviewCarouselMine',
                  component: PreviewCarouselMine,
                }
              ]
            },
            {
              path: 'preview-carousel',
              name: 'PrePreviewCarousel',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: ':id',
                  name: 'Preview Carousel',
                  component: PreviewCarousel,
                }
              ]
            },
            {
              path: 'preview-carousel2',
              name: 'PrePreviewCarousel2',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: ':id',
                  name: 'Preview Carousel2',
                  component: PreviewCarousel2,
                }
              ]
            },
            {
              path: 'preview',
              name: 'Preview',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: ':id',
                  name: 'Preview Design',
                  component: Preview,
                }
              ]
            },
            {
              path: 'preview-mine',
              name: 'PreviewMine',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: ':id',
                  name: 'Preview Mine',
                  component: PreviewMine,
                }
              ]
            }
          ]
        },
        {
          path: 'choose-color',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ':id',
              name: 'ChooseColor',
              component: ChooseColor,
              props: true
            },
          ]
        },
        {
          path: 'editor',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ':id',
              name: 'Editor',
              component: isMobile ? EditorMobile: Editor,
              props: true
            },
            {
              path: 'tests/:id',
              name: 'EditorTests',
              component: EditorTests,
              props: true
            },
          ]
        },
        {
          path: 'faq/:number?',
          name: 'FAQ',
          component: FAQ
        },
        {
          path: 'tutorial',
          name: 'Tutorial',
          component: Tutorial
        },
        {
          path: 'support',
          name: 'Suporte',
          component: Support
        },
        {
          path: 'request-sleeker',
          name: 'Sugerir Sleeker',
          component: RequestSleeker
        },
        {
          path: 'payments',
          name: 'Pagamentos',
          component: Payments
        },
        {
          path: 'payments2',
          name: 'Pagamentos2',
          component: Payments2
        },
        {
          path: 'account',
          name: 'Conta',
          component: Account
        },
        {
          path: 'club',
          name: 'Sleeker Club',
          component: Club
        },
        {
          path: 'reseller-manage',
          name: 'ResellerManage',
          component: ResellerManage
        },
        {
          path: 'site',
          name: 'Site',
          component: {render (c) { return c('router-view') }},
          children: [{
              path: 'home',
              name: 'SiteHome',
              component: SiteHome
            },
            {
              path: 'page/:id?',
              name: 'SitePage',
              component: SitePage
            },
            {
              path: 'leads',
              name: 'SiteLeads',
              component: SiteLeads
            }
          ]
        },
        {
          path: 'freepass',
          name: 'FreePassHome',
          component: FreePassHome
        },
        {
          path: 'freepass-video/:page?',
          name: 'FreePassVideo',
          component: FreePassVideo
        },
        {
          path: 'freepass-sticker',
          name: 'FreePassSticker',
          component: FreePassSticker
        },
        {
          path: 'docs',
          name: 'DocsParent',
          component: {render (c) { return c('router-view') }},
          children: [{
              path: 'home',
              name: 'DocHome',
              component: DocHome
            },
            {
              path: 'list',
              name: 'DocList',
              component: DocList
            },
            {
              path: 'mine',
              name: 'DocMine',
              component: DocMine
            },
            {
              path: 'finished',
              name: 'DocFinished',
              component: DocFinished
            },
            {
              path: ':id',
              name: 'Docs',
              component: Docs
            }
          ]
        }
      ]
    },
    {
      path: '/site',
      name: 'SiteSingle',
      component: {render (c) { return c('router-view') }},
      children: [
        {
          path: 'editor/:id',
          name: 'SiteEditor',
          component: SiteEditor
        },
        {
          path: 'admin-editor/:id',
          name: 'SiteEditorAdmin',
          component: SiteEditorAdmin
        }
      ]
    },
    {
      path: '/curso',
      name: 'Curso',
      component: Raffle
    },
    {
      path: '/lecture/:key',
      name: 'Lecture',
      component: Lecture
    },
    {
      path: '/aula/:key',
      name: 'Lecture2',
      component: Lecture2
    },
    {
      path: '/admin',
      redirect: '/admin/list',
      name: 'Admin',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: AdminDashboard
        },
        {
          path: 'history',
          name: 'History',
          component: AdminHistory
        },
        {
          path: 'fonts',
          name: 'AdminFonts',
          component: AdminFonts
        },
        {
          path: 'sales',
          name: 'SalesPanel',
          component: AdminSalesPanel
        },
        {
          path: 'list',
          name: 'Listagem',
          component: AdminPanel
        },
        {
          path: 'creation',
          redirect: '/creation/list',
          name: 'Creation',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'CreationManagement',
              component: CreationManagement
            },
            {
              path: 'add',
              name: 'CreationAdd',
              component: CreationAdd
            },
            {
              path: 'update/:id',
              name: 'CreationUpdate',
              component: CreationUpdate
            },
            {
              path: 'productivity',
              name: 'CreationProductivity',
              component: CreationProductivity
            },
            {
              path: 'sources',
              name: 'CreationSources',
              component: CreationSources
            },
            {
              path: 'productivity-by-admin',
              name: 'CreationProductivityByAdmin',
              component: CreationProductivityByAdmin
            }
            
          ]
        }
      ]
    },
    {
      path: '/payments-page',
      name: 'PagamentosPage',
      component: PaymentsPage
    },
    {
      path: '/payments/load',
      name: 'PaymentLoad',
      component: PaymentLoad
    }
    ,
    {
      path: '/payments/success',
      name: 'PaymentSuccess',
      component: PaymentSuccess
    },
    {
      path: '/coupon',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: ':name',
          name: 'Coupon',
          component: Coupon,
        },
      ]
    },
    {
      path: '/invite',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: ':invite',
          name: 'Invite',
          component: Invite,
        },
      ]
    },
    {
      path: '/coupons',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: ':name',
          name: 'Coupons',
          component: Coupons,
        },
      ]
    },
    {
      path: '/reseller',
      redirect: '/reseller/list',
      name: 'Reseller',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'list',
          name: 'ListagemReseller',
          component: ResellerPanel
        }
      ]
    },
    {
      path: '/reseller/user',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: ':id/:type?',
          name: 'ResellerUser',
          component: ResellerUser,
        },
      ]
    },
    {
      path: '/user/edition',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: ':id',
          name: 'UserEdition',
          component: UserEdition,
        },
      ]
    },
    {
      path: '/template/editions',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: ':id',
          name: 'TemplateEditions',
          component: TemplateEditions,
        },
      ]
    },
    {
      path: '/conhecer',
      name: 'GetToKnow',
      component: GetToKnow
    },
    {
      path: '/freepass',
      name: 'FreePass',
      component: FreePass
    },
    {
      path: '/imersao',
      name: 'Imersao',
      component: Imersao
    },
    {
      path: '/whatsapp',
      name: 'Whatsapp',
      component: Whatsapp
    },
    {
      path: '/entrar',
      name: 'PreLogin',
      component: PreLogin
    },
    {
      path: '/tests',
      name: 'Tests',
      component: Tests
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'download-video/:id',
          name: 'DownloadVideo',
          component: DownloadVideo
        },
        {
          path: 'challenge-single',
          name: 'ChallengeSingle',
          component: ChallengeListComponent
        },
        {
          path: 'ebook-single',
          name: 'EbookSingle',
          component: EbookSingle
        },
        {
          path: 'register',
          name: 'Register',
          component: Register,
          redirect: '/pages/login'
        },
        {
          path: 'reset-password',
          name: 'ResetPassword',
          component: ResetPassword
        },
        {
          path: 'confirm-email',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ':token',
              name: 'EmailConfirmation',
              component: EmailConfirmation,
            }
          ]
        },
        {
          path: 'create-password',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ':token',
              name: 'CreatePassword',
              component: ResetPasswordCreation,
            }
          ]
        }
      ]
    },
    { path: "*", component: Page404 },
    { name: 'NotFound', path: "/not-found", component: Page404 }
  ]
})
